import { Location } from '@angular/common';
import { Component, isDevMode, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { config } from '@app/core/app-config';
import { SignupUserService as NewSignupUserService } from '@app/modules/signup-new/services/signup-user.service';
import { UsersFacade } from '@app/shared/+state/users';
import { LoadingState, NotificationType, QueryParams } from '@app/shared/interfaces';
import { SegmentEvent, SegmentIoService } from '@app/shared/services/segmentIo/segment-io.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { RecaptchaComponent } from 'ng-recaptcha';
import { Observable } from 'rxjs';
import { SignupWizardService } from '../signup-wizard.service';
import { Testimonial } from '../signup.interface';

@Component({
  standalone: false,
  selector: 'sbnb-signup-welcome',
  templateUrl: './signup-welcome.component.html',
  styleUrls: ['./signup-welcome.component.scss'],
})
export class SignupWelcomeComponent implements OnInit {
  stage1Form: UntypedFormGroup;
  stage2Form: UntypedFormGroup;
  validatingEmail: boolean;
  submittingStage2: boolean;
  emailError: string;
  startingOver: boolean;
  leftOffLoading: boolean;
  leftOffLoaded: boolean;

  invitedUserDocUrl =
    'http://help.hospitable.com/en/articles/4631570-i-received-an-invite-to-access-smartbnb-should-i-sign-up-and-create-a-new-account';

  config = config;

  stage = 1;

  preferredCountries = ['us'];

  testimonials: Testimonial[] = [
    {
      platform: 'trustpilot',
      user: { name: 'Dan Yen' },
      title: 'If you are serious about your short…',
      review_url: 'https://www.trustpilot.com/reviews/5efaeccd7dd75306b8d12150',
      review:
        'If you are serious about your short term rental business Hospitable is an absolute must!!! It not only improves your service to your customer but also allows you to better manage your key operational tasks and increase your income! Can’t recommend Hospitable enough!!',
    },
    {
      platform: 'trustpilot',
      user: { name: 'Hendrik ten Napel' },
      title: '5* reviews due to Hospitable',
      review_url: 'https://www.trustpilot.com/reviews/5e8f108f086b6409bc80c4e2',
      review: `Hospitable is reall helps you managing your Bed & Breakfast. It takes away all mails and responses and the automatic reviews are really handy. I've got a consequent 5* review on communication while Hospitable does all the work. thank you folks!`,
    },
    {
      platform: 'g2',
      user: { name: 'G2 reviewer' },
      title: `Hosting with Hospitable it's the best.`,
      review_url: 'https://www.g2.com/products/smartbnb/reviews/smartbnb-review-4249185',
      review: `Everything is planned to help hosts and automatically be in contact 24/7 with your guests and it will be a big plus when you receive the review. Follow you in almost all your steps from inquiry to booking and then during the stay you can plan a couple of messages for exemple, first morning, day before departure with checkout instructions. All of this without you need to login to your account. Customize as much you can and then relax and enjoy some of your time in family without interruptions. Simple the best tool for hosting. `,
    },
    {
      platform: 'g2',
      user: { name: 'Jan S' },
      title: `Invaluable!`,
      review_url: 'https://www.g2.com/products/smartbnb/reviews/smartbnb-review-4216360',
      review: `I rely on Hospitable to respond quickly and consistently to inquiries. It also sends automatic updates to my cleaners, which is critical. It interfaces with my main listings and lets me focus on other aspects of my business.`,
    },
    {
      platform: 'g2',
      user: { name: 'Gil S' },
      title: `Improves customer experience, saves time & becomes SUPER responsive!`,
      review_url: 'https://www.g2.com/products/smartbnb/reviews/smartbnb-review-4229717',
      review: `With Hospitable message automation, we are super responsive our clients and they are always impressed with the info we stream their way to make their visit a 5 star experience.`,
    },
    {
      platform: 'g2',
      user: { name: 'Omar T' },
      title: `Very accommodating!`,
      review_url: 'https://www.g2.com/products/smartbnb/reviews/smartbnb-review-4223081',
      review: `Hospitable helps me to keep on top of guest communications. Guest would always say I'm always reachable, and I provide pertinent information without them asking. It's one less thing to worry about when you're super busy doing other things.`,
    },
    {
      platform: 'capterra',
      user: { name: 'Tim E.' },
      title: `Simplifies short term rental management`,
      review_url: 'https://www.capterra.com/p/189280/smartbnb/reviews/2148798/',
      review: `The biggest thing by far is the automated email platform. It's highly customisable, and after a bit of playing round I was able to come up with a setup that I am very happy with, with most of the routine emails being sent automatically.`,
    },
    {
      platform: 'capterra',
      user: { name: 'Elkin A.' },
      title: `Great Automation/Communication Software`,
      review_url: 'https://www.capterra.com/p/189280/smartbnb/reviews/2084436/',
      review: `Everything! It does what it says for a fair price. Hospitable saves me hours of works every single week. In summary, if you are in the STR business, stop reading reviews and go and get a free trial. You can thank me later ;)`,
    },
    {
      platform: 'capterra',
      user: { name: 'John M.' },
      title: `Smart BnB saves me hours per week managing vacation rentals!`,
      review_url: 'https://www.capterra.com/p/189280/smartbnb/reviews/1722764/',
      review: `Automated Messaging Hospitable would be worth it for this feature alone. My entire message flow is automated, and most of the time I don't even send a message during guest's stay. It auto-responds to new bookings, making my response time essentially instant. And it even automatically leaves reviews fo the guests.`,
    },
    {
      platform: 'trustpilot',
      user: { name: 'Ab Mamman' },
      title: `Automate your airbnb and get your life back`,
      review_url: 'https://www.trustpilot.com/reviews/5e9230f4086b6409bc827ede',
      review: `I have been hosting since 2014 and I just started using Hospitable 2 years ago but it has been a complete gamechanger for me. Very reasonably priced I would highly recommend them to all hosts!! I saved so much time automating my msgs and tasks `,
    },
    {
      platform: 'trustpilot',
      user: { name: 'Eduard' },
      title: `Hospitable automates everything!`,
      review_url: 'https://www.trustpilot.com/reviews/5e9482ab086b64095435e5bc',
      review: `Hospitable has been of great help for me as a host who is busy with my day job. The automatic reply features have been really helpful and amazing to ensure conversion of inquries into bookings. The staff are also very responsive in case you encounter issues with your account. Since I started Hospitable, my bookings have increased tremendously and I have been a Superhost for 18 consecutive months. More power to the team and thank you!`,
    },
    {
      platform: 'trustpilot',
      user: { name: 'Taione' },
      title: `Hospitable has been tremendous in helping…`,
      review_url: 'https://www.trustpilot.com/reviews/5e978479086b6409bc856c93',
      review: `Hospitable has been tremendous in helping me close more of booking inquiries and ensuring a consistent guest experience throughout the whole guest stay duration. It has given me a competitive edge in market as others have a significantly lesser response time. Hospitable as a company are very trustworthy and understanding to all aspects of the STR business and are always eager to help you grow during the good times or survive the down times. I would highly recommend Hospitable to other STR operators. `,
    },
    {
      platform: 'trustpilot',
      user: { name: 'More Space Real Estate' },
      title: `Hospitable is a wonderful app`,
      review_url: 'https://www.trustpilot.com/reviews/5e988c65086b6409543894ef',
      review: `Hospitable is a wonderful app. They do an excellent job of wording and formatting great messages to your guests for you. I have been using them for a few months and have been happy with the results. Even the experience I have had with their customer service has been great. They are prompt and very helpful. I would recommend new and experienced host to use Hospitable for the property/guest management.`,
    },
    {
      platform: 'trustpilot',
      user: { name: 'Paul' },
      title: `A “must-have” tool for AirBnB owners`,
      review_url: 'https://www.trustpilot.com/reviews/5e98cc8a086b64095438cb52',
      review: `I LOVE Hospitable and could not imagine running my short term rental without this tool. Their customer service is outstanding and the amount of time this tool saves me is incredible. Hospitable has helped me maintain my Superhost status by providing great communication with my guests for over 2 years now. Well worth every single cent! `,
    },
    {
      platform: 'trustpilot',
      user: { name: 'Paul F' },
      title: `A must have when you are a host`,
      review_url: 'https://www.trustpilot.com/reviews/5e9e352d086b6409bc894c8d',
      review: `A must have when you are a host on Airbnb!! Hospitable saves soo much time in managing not only guests but also staff! It is a pleasure to have this software addon in this industry. Thanks so much!`,
    },
    {
      platform: 'trustpilot',
      user: { name: 'Denise Hilton' },
      title: `Hospitable is the BEST!`,
      review_url: 'https://www.trustpilot.com/reviews/5da64f4e6048580adca7be2c',
      review: `I love Hospitable! It has changed my life for the better in so many ways. I have taken back a significant amount of time that I would have spent trying to remember all the reservations and then sending constant messages to my guests in my very busy rental. I now have time to focus my attention on growing my business in other ways. The customer support is top notch a well. Almost instant responses via chat which is I prefer. I highly recommend it!`,
    },
    {
      platform: 'trustpilot',
      user: { name: 'Nikki Rogers' },
      title: `I’ve never looked back!`,
      review_url: 'https://www.trustpilot.com/reviews/5d83ec9f3585c70ef0de04fd',
      review: `Living so far away from my Airbnb property, I was worried about being able to manage the bookings properly. My friend introduced me to Hospitable and I have never looked back! Easy to Manage and takes the hassle out of any booking. I can not recommend highly enough. `,
    },
    {
      platform: 'trustpilot',
      user: { name: 'Carlos' },
      title: `After testing every option out there`,
      review_url: 'https://www.trustpilot.com/reviews/5d8cef283585c709a46333f5',
      review: `After testing every option out there, Hospitable is light years ahead of every other tool available and it is inexpensive.`,
    },
    {
      platform: 'trustpilot',
      user: { name: 'Stephanie Alexander' },
      title: `Hospitable has made renting out my…`,
      review_url: 'https://www.trustpilot.com/reviews/5d9bafce6b04580b54578932',
      review: `Hospitable has made renting out my vacation home a breeze! My cleaning gal knows when new stays are booked, and I am able to communicate quickly and efficiently with my guests with automated messages.`,
    },
  ];
  chunkedTestimonials: Testimonial[][];
  partnerDiscountCode: string | null = null;

  LoadingState = LoadingState;
  airbnbSignUpError = true;
  isAirbnbSignup = false;
  airbnbSignUpErrorMessage$: Observable<string | null>;
  shouldShowAirbnbSignup = true;

  @ViewChild('captchaRef') captchaRef: RecaptchaComponent;

  constructor(
    public wizard: SignupWizardService,
    private toast: ToastNotificationsService,
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private usersFacade: UsersFacade,
    private segmentIoService: SegmentIoService,
    private readonly newSignupUserService: NewSignupUserService
  ) {}

  ngOnInit() {
    if (this.shouldShowAirbnbSignup) {
      this.segmentIoService.track(SegmentEvent.SignUpWithAirbnbShown, {});
    }

    if (this.wizard.signupUser.current_step > 2) {
      this.router.navigateByUrl('/user/register/welcome/start');
      return;
    }

    this.route.queryParamMap.subscribe((queryParam: ParamMap) => {
      if (queryParam.has('code')) {
        this.partnerDiscountCode = queryParam.get('code');
      }

      if (queryParam.has('email')) {
        this.wizard.signupUser.email = queryParam.get('email');
      }
    });

    this.airbnbSignUpErrorMessage$ = this.usersFacade.signUpWithAirbnbError$;

    this.initForms();

    this.route.queryParams.subscribe((params: any) => {
      const error = params[QueryParams.AirbnbError];
      this.airbnbSignUpError = error ? true : false;

      if (params[QueryParams.AirbnbSignup]) {
        this.isAirbnbSignup = this.wizard.isAirbnbSignup();

        if (this.isAirbnbSignup) {
          this.initForms();
          this.initialisePhase2();
        }
      }
    });

    if (this.wizard.signupUser.token) {
      // this.location.go('/user/register/welcome/personal');
      this.stage = 2;
    } else {
      this.wizard.startOver();
    }

    this.chunkedTestimonials = this.chunkTestimonials(this.testimonials, Math.ceil(this.testimonials.length / 2));
  }

  initForms() {
    this.stage1Form = new UntypedFormGroup({
      email: new UntypedFormControl(
        { value: this.wizard.signupUser.email, disabled: false },
        { validators: [Validators.required] }
      ),
    });

    this.stage2Form = new UntypedFormGroup({
      email: new UntypedFormControl(
        { value: this.wizard.signupUser.email, disabled: true },
        { validators: [Validators.required] }
      ),
      first_name: new UntypedFormControl(
        { value: this.wizard.signupUser.first_name, disabled: false },
        { validators: [Validators.required] }
      ),
      last_name: new UntypedFormControl(
        { value: this.wizard.signupUser.last_name, disabled: false },
        { validators: [Validators.required] }
      ),
      mobile_phone: new UntypedFormControl(
        { value: this.wizard.signupUser.mobile_phone, disabled: false },
        { validators: [Validators.required] }
      ),
      agreed_to_tos: new UntypedFormControl(
        { value: this.isAirbnbSignup ? true : false, disabled: false },
        { validators: [Validators.requiredTrue] }
      ),
    });
  }

  checkCaptcha() {
    if (isDevMode()) {
      this.createNewUser(
        this.stage2Form.get('email').value,
        this.stage2Form.get('first_name').value,
        this.stage2Form.get('last_name').value,
        this.stage2Form.get('mobile_phone').value,
        this.stage2Form.get('agreed_to_tos').value
      );
    } else {
      this.captchaRef.execute();
    }
  }

  validateEmail(email: string) {
    this.validatingEmail = true;
    this.wizard.validateEmail(email).subscribe((res) => {
      this.validatingEmail = false;

      if ('error' in res) {
        this.emailError = res.message;
        return;
      }

      this.emailError = '';

      switch (this.wizard.signupUser.status) {
        case 'invited':
          this.emailError = 'Please accept the invite you have received.';
          break;

        case 'existing':
          this.emailError = 'An account with this email already exists.';
          break;

        case 'login_restricted':
          this.newSignupUserService.user$.next(this.wizard.signupUser);
          this.router.navigate(['/signup/restricted']);
          break;

        case 'returning':
          this.gotoReturning();
          break;

        case 'new':
          this.initialisePhase2();
          break;
      }
    });
  }

  initialisePhase2() {
    this.stage2Form.get('email').setValue(this.wizard.signupUser.email);
    this.stage2Form.get('first_name').setValue(this.wizard.signupUser.first_name);
    this.stage2Form.get('last_name').setValue(this.wizard.signupUser.last_name);
    this.stage2Form.get('mobile_phone').setValue(this.wizard.signupUser.mobile_phone);

    this.prefillCountryCode();

    // this.location.go('/user/register/welcome/personal');
    this.stage = 2;
  }

  prefillCountryCode() {
    // Push the country from the SignupUser object onto the front of the telephone preferred countries list
    if (
      this.wizard.signupUser.country_code &&
      this.wizard.signupUser.country_code.length === 2 &&
      this.wizard.signupUser.country_code.toLowerCase() !== 'us'
    ) {
      this.preferredCountries.unshift(this.wizard.signupUser.country_code.toLowerCase());
    }
  }

  // If we have the user marked as existing, and they then edit their email during the 'Take me to login' then we revert back
  ifExistingRevertToNew() {
    if (this.wizard.signupUser.status === 'existing' || this.wizard.signupUser.status === 'invited') {
      this.wizard.signupUser.status = 'new';
      this.emailError = null;
    }
  }

  createNewUser(
    email: string,
    first_name: string,
    last_name: string,
    mobile_phone: string,
    agreed_to_tos: boolean,
    captcha = 'notusedonbackend'
  ) {
    this.submittingStage2 = true;

    this.wizard
      .createSignupUser(email, first_name, last_name, mobile_phone, agreed_to_tos, captcha, this.partnerDiscountCode)
      .subscribe((res) => {
        this.submittingStage2 = false;

        if ('error' in res) {
          this.toast.open(
            res.message || `We ran into an error creating a user. Please try again shortly.`,
            'Dismiss',
            NotificationType.Error
          );

          this.captchaRef.reset();

          return;
        }
        this.gotoNext();
      });
  }

  goBackToWhereILeftOff() {
    this.leftOffLoading = true;
    this.wizard.goBackToWhereILeftOff(this.wizard.signupUser.email).subscribe((res) => {
      this.leftOffLoading = false;

      if ('error' in res) {
        return;
      }

      this.leftOffLoaded = true;
    });
  }

  startOver() {
    this.startingOver = true;
    this.wizard.forgetUserAndStartOver(this.wizard.signupUser.email).subscribe((res) => {
      this.startingOver = false;
      this.initialisePhase2();
    });
  }

  gotoNext() {
    this.wizard.next();
  }

  gotoReturning() {
    this.location.go('/user/register/welcome/returning');
    this.stage = 3;
  }

  guideInvited() {
    window.location.href = this.invitedUserDocUrl;
  }

  chunkTestimonials(testimonials: Testimonial[], chunkSize: number): Testimonial[][] {
    const chunks = [];
    for (var i = 0, j = testimonials.length; i < j; i += chunkSize) {
      chunks.push(testimonials.slice(i, i + chunkSize));
    }
    return chunks;
  }

  signUpWithAirbnb() {
    this.router.navigateByUrl('/user/register/airbnb');
  }
}
